import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Table } from 'reactstrap';
import Api from '../../../util/api';
import Pagination from '../../../shared/components/pagination/Pagination';
import t, { partial } from '../../../util/translation/translation';
import { formatDateTime } from '../../../util/date-and-time';

const SubscriptionsList = ({ auctionItemId, setLoading }) => {
  const p = partial('auctionObjectsShared');
  const s = partial('shared');
  const [subscriptions, setSubscriptions] = useState([]);

  const [pagination, setPagination] = useState({
    total: 0,
    currentPage: 1,
    perPage: 10,
  });

  const fetchSubscriptions = async (currentPage = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const resSubscriptions = await Api.auctions.getAuctionItemSubscribers(
        auctionItemId,
        { page: currentPage, take: pageSize }
      );
      const userIds = [
        ...new Set(
          resSubscriptions.data
            .map((item) => item.userId)
            .filter((userId) => userId !== null)
        ),
      ];
      const { data: usersByIds } = await Api.users.getUsersByCloudIds(userIds);
      const userByIdMap = {};
      for (let i = 0; i < usersByIds.length; i++) {
        userByIdMap[usersByIds[i].userCloudId] = usersByIds[i];
      }
      const mappedSubscriptions = resSubscriptions.data.map((subscription) => ({
        ...subscription,
        user: userByIdMap[subscription.userId],
      }));
      setSubscriptions(mappedSubscriptions);
      setPagination((old) => ({ ...old, total: resSubscriptions.count }));
      setLoading(false);
    } catch (err) {
      toast.error(p('autoBidsRetrievingERROR'));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (auctionItemId) {
      fetchSubscriptions();
    }
  }, [auctionItemId]);

  const onChangePage = (pager) => {
    if (
      pager.pageSize !== pagination.perPage ||
      pager.currentPage !== pagination.currentPage
    ) {
      setPagination((old) => ({
        ...old,
        currentPage: pager.currentPage,
        perPage: pager.pageSize,
      }));
      fetchSubscriptions(pager.currentPage, pager.pageSize);
    }
  };

  const renderSubscriptions = () => {
    return subscriptions.map((subscription, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`subscription-${subscription.id}`}
      >
        <td>
          <div className="flex-Vcenter">
            <div>
              <Link
                to={`/users/edit/${subscription.userId}`}
              >{`${subscription.user?.firstname} ${subscription.user?.lastname}`}</Link>
              <br />
              <span
                style={{ fontSize: 10 }}
              >{`${subscription.user?.phoneNumber}`}</span>
              <br />
              <span
                style={{ fontSize: 10 }}
              >{`${subscription.user?.email}`}</span>
            </div>
          </div>
        </td>

        <td>{formatDateTime(subscription.createdAt)}</td>
      </tr>
    ));
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          paddingBottom: 5,
          marginTop: 10,
          background: '#fff',
          borderRadius: 6,
          boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
        }}
      >
        <Table responsive striped>
          <thead>
            <tr>
              <th style={{ color: '#4D576A' }} className="sortable">
                <div className="flex alignItems-center">{s('user')}</div>
              </th>
              <th style={{ color: '#4D576A' }}>
                <div className="flex alignItems-center">{s('date')}</div>
              </th>
              <th />
            </tr>
          </thead>
          <tbody>{renderSubscriptions()}</tbody>
        </Table>
      </div>
      <Pagination
        items={pagination.total}
        onChangePage={onChangePage}
        initialPage={pagination.currentPage}
      />
    </>
  );
};

export default SubscriptionsList;
